"use strict";

import React from "react";
import { render } from "react-dom";
import { Nav, BelNav, BelNavAux } from "./nav.js";
import basicData from "./basic_data.js";

const RelevantNav = basicData.survey.is_bel_shaped ? BelNav : Nav;

render(
  <RelevantNav {...basicData} />,
  document.querySelector("#react_navbar_target"),
);

if (basicData.survey.is_bel_shaped) {
  // for BEL, some links are rendered within the "main" header instead of the navbar
  render(<BelNavAux />, document.querySelector("#react_bel_aux_nav"));
}
